export default { sha: '20579a452d8dcd1e1f9e49d12b84e7471e0acd11', buildNumber: 'undefined' }
